import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ChartsJS from '../../../Charts/ChartJs/index';
import ReactVis from '../../../Charts/ReactVis/index';
import Recharts from '../../../Charts/Recharts/index';

export default () => (
  <Routes>
    <Route path="/charts/charts_js" element={<ChartsJS />} />
    <Route path="/charts/react_vis" element={<ReactVis />} />
    <Route path="/charts/recharts" element={<Recharts />} />
  </Routes>
);
